var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28591 11.8395L3.91091 7.46452C3.84973 7.40355 3.80119 7.3311 3.76807 7.25134C3.73495 7.17157 3.71789 7.08605 3.71789 6.99967C3.71789 6.9133 3.73495 6.82778 3.76807 6.74801C3.80119 6.66824 3.84973 6.5958 3.91091 6.53483L8.28591 2.15983C8.4092 2.03655 8.57641 1.96729 8.75076 1.96729C8.92511 1.96729 9.09232 2.03655 9.2156 2.15983C9.33888 2.28311 9.40814 2.45032 9.40814 2.62467C9.40814 2.79902 9.33888 2.96623 9.2156 3.08952L5.3049 7.00022L9.21615 10.9109C9.33943 11.0342 9.40869 11.2014 9.40869 11.3758C9.40869 11.5501 9.33943 11.7173 9.21615 11.8406C9.09286 11.9639 8.92565 12.0332 8.7513 12.0332C8.57695 12.0332 8.40974 11.9639 8.28646 11.8406L8.28591 11.8395Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyArrow);
export default __webpack_public_path__ + "static/media/greyArrow.4cc7622fd0c8a327e2b4739748ff84b4.svg";
export { ForwardRef as ReactComponent };